import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_primebot.png",
      alt: "Estratégias PrimeBot",
    },
    title: "As estratégias da PrimeBot de uma forma ainda mais fácil!",

    // String ou array de strings
    text: [
      "Agora você pode utilizar as estratégias da PrimeBot Portfólio com apenas alguns cliques.",
      "Com a PrimeBot você opera de forma 100% automatizada através de estratégias criadas através de um processo objetivo de gestão de riscos e eliminando os efeitos negativos da emoção no processo de decisório.",
    ],
    // testimonial: {
    //   text: "Risco é o combustível do Trader, mas se não for calculado será a sua derrota!",
    //   author: {
    //     name: "Mário Vilas Boas, Analista CNPI-T 2817",
    //     picture: "",
    //   },
    // },
  },

  strategies: {
    title: "PrimeBot Portfólio",
    heading: "Conheça nossas estratégias.",
    subtitle:
      "Estratégias desenvolvidas por profissionais e disponível para você em poucos cliques!",
  },

  cta: {
    title: "Invista com nosso portfólio!",
    subtitle: "Assine a extensão PrimeBot.",
  },

  about: {
    title: "Sobre o analista",
    subtitle: "A PrimeBot",
    col1: [
      "A Primebot Portfolio é uma empresa que criou um Expert Advisor para a plataforma MetaTrader 5 muito completo, contando com vários indicadores e parâmetros onde você automatiza seus investimentos e até mesmo testar estratégias diferentes escolhendo diversos gerenciamentos de risco diferentes também e com opção de personalizar cada estratégia ou gerenciamentos inclusos.",
    ],
    // col2: [
    //   "",
    // ],
  },

  // stats: {
  //   title: "Por que utilizar a PrimeBot Portfólio?",
  //   subtitle: "Mais de 5 anos de experiência de mercado.",
  //   data: [
  //     {
  //       value: "+5",
  //       description: "Anos de experiência",
  //     },
  //     {
  //       value: "+90",
  //       description: "Ativos analisados",
  //     },
  //     {
  //       value: "1",
  //       description: "Analista CNPI",
  //     },
  //   ],
  // },

  features: {
    title: "Por que utilizar a PrimeBot Portfólio?",
    subtitle: "Veja quais as principais vantagens da PrimeBot.",
    data: [...defaultContent.features.data],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão PrimeBot",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
